import Wrapper from "../../../layout/Wrapper";
import ChangePasswordComponent from "../../../screens/settings/chage-password";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Change Password",
	description: "",
};

export default function ChangePassword() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<ChangePasswordComponent />
		</Wrapper>
	);
}